import { render } from "./WelcomePane.vue?vue&type=template&id=236f67e4"
import script from "./WelcomePane.vue?vue&type=script&lang=js"
export * from "./WelcomePane.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__